import { useLocation } from "react-router";
import { Link } from "react-router-dom";

export default function Fallback({errorCode}){
    const {state, pathname} = useLocation();
    const routeData = state ? JSON.parse(state) : {};
    
    const errorMessages = {
        404: "Oops! The page you are looking for was not found.",
        403: "You are not authorized to view this page.",
        default: "Something went wrong. Please try again."
    }
    const code = errorCode || routeData?.errorCode;
    const message = errorMessages[errorCode || routeData?.errorCode] || errorMessages.default;

    return (   
        <div className="container text-center py-5">
            <div className="card my-5 py-5 shadow-sm bg-light">
                <h2 className="fw-bold">{code}</h2>
                <p className="my-2">{message}</p>
                <p>Path: <span className="">{pathname}</span></p>
                <Link to={"/"} className="btn kg-btn kg-primary py-2">Go to Home</Link>
            </div>
        </div>
    )
}